exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-settlement .header-tip[data-v-5c683d46]{font-size:14px;margin:10px;color:#ccc}.create-settlement .header-date[data-v-5c683d46]{margin:10px}.create-settlement .content[data-v-5c683d46]{margin-top:40px}.create-settlement .content .create-settle-pagination[data-v-5c683d46]{margin-top:40px;height:40px;text-align:right}.create-settlement .bottom[data-v-5c683d46]{width:500px;position:fixed;bottom:20px;left:50%;margin-left:-50px}\n", ""]);

// exports
